const lunch = [
    {
        id: 1,
        name: 'Caesar salad',
        description: 'chicken breast, romaine lettuce, croutons, parmesan',
        price: '15.50'
    },
    {
        id: 2,
        name: 'Spaghetti carbonara',
        description: 'spaghetti, pancetta, garlic, eggs, parmesan, pepper',
        price: '11.65'
    },
    {
        id: 3,
        name: 'Pizza',
        description: 'chorizo, italian salami, tomatoes, mushrooms, olives',
        price: '12.90'
    }
];

export default lunch;